import { render, staticRenderFns } from "./LimitProgressCard.vue?vue&type=template&id=acb142d6"
import script from "./LimitProgressCard.vue?vue&type=script&lang=js"
export * from "./LimitProgressCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports